import React from 'react';
import { useNavigate } from 'react-router-dom';
import s from './ConsistencySection.module.css';
import avatarImage from './images/avatar.svg';
import postImage from './images/product.svg';
import productImage2 from './images/image (8) 1.png';
import { motion } from 'framer-motion';
import {
    OptimizedMotion,
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const ConsistencySection: React.FC = () => {
    const navigate = useNavigate();

    const handleStayOnBrand = () => {
        navigate('/contact');
    };

    return (
        <section className={s.container}>
            <div className={s.content}>
                <div className={s.postsContainer}>
                    {/* Pinterest-style post */}
                    <OptimizedMotion type="slide-up" delay={0.3} className={s.pinterestPost}>
                        <div className={s.postImage}>
                            <img src={postImage} alt="Product" className={s.image} />
                        </div>
                        <div className={s.pinterestFooter}>
                            <div className={s.userInfo}>
                                <div className={s.avatar}>
                                    <img
                                        src={avatarImage}
                                        alt="Max Willow"
                                        className={s.avatarImage}
                                    />
                                </div>
                                <span className={s.userName}>Max Willow</span>
                            </div>
                            <p className={s.postText}>
                                It may look like a dream, but dreams often hold deeper truths. They
                                can reveal our hidden design and aspirations, guiding us toward our
                                true selves. By exploring these visio...
                            </p>
                            <div className={s.pinterestActions}>
                                <button className={s.iconButton}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                                <button className={s.iconButton}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                                <button className={s.iconButton}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <polyline
                                            points="16 6 12 2 8 6"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <line
                                            x1="12"
                                            y1="2"
                                            x2="12"
                                            y2="15"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                                <button className={s.iconButton}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="1"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        />
                                        <circle
                                            cx="12"
                                            cy="5"
                                            r="1"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        />
                                        <circle
                                            cx="12"
                                            cy="19"
                                            r="1"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        />
                                    </svg>
                                </button>
                                <button className={s.saveButton}>Save</button>
                            </div>
                        </div>
                    </OptimizedMotion>

                    {/* Instagram/TikTok-style post */}
                    <OptimizedMotion type="slide-up" delay={0.6} className={s.storyPost}>
                        <div className={s.storyImage}>
                            <img src={productImage2} alt="Product Story" className={s.image} />
                            <div className={s.storyOverlay}>
                                <div className={s.storyHeader}>
                                    <div className={s.storyUserInfo}>
                                        <div className={s.storyAvatar}>
                                            <img
                                                src={avatarImage}
                                                alt="Max Willow"
                                                className={s.avatarImage}
                                            />
                                        </div>
                                        <span className={s.storyUserName}>@Max Willow</span>
                                        <button className={s.subscribeButton}>Subscribe</button>
                                    </div>
                                </div>
                                <div className={s.storyFooter}>
                                    <p className={s.storyText}>
                                        It may look like a dream, but dreams often hold deeper
                                        truths. They can reveal our hidden design and aspirati...
                                    </p>
                                    <div className={s.storyTags}>
                                        <span className={s.tag}>#911</span>
                                        <span className={s.tag}>#porscxhe</span>
                                        <button className={s.showMoreButton}>Show more</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </OptimizedMotion>
                </div>

                <div className={s.textContent}>
                    <OptimizedMotionH1 type="slide-left" delay={0.8} className={s.title}>
                        Stay consistent everywhere — automatically.
                    </OptimizedMotionH1>
                    <div className={s.descriptionList}>
                        <OptimizedMotionP type="slide-left" delay={0.9} className={s.description}>
                            Whether you're posting, launching, or scaling — SimpleeCreate keeps your
                            visuals aligned across every channel.
                        </OptimizedMotionP>
                        <OptimizedMotionP type="slide-left" delay={1.0} className={s.description}>
                            Your brand looks cohesive, professional, and premium — everywhere your
                            customers see you.
                        </OptimizedMotionP>
                        <OptimizedMotionP type="slide-left" delay={1.0} className={s.description}>
                            Consistency builds trust. Trust drives sales.
                        </OptimizedMotionP>
                    </div>
                    <OptimizedMotion
                        type="slide-right"
                        delay={1.0}
                        className={s.ctaButton}
                        onClick={handleStayOnBrand}
                    >
                        Stay on-brand
                    </OptimizedMotion>
                </div>
            </div>
        </section>
    );
};

export default ConsistencySection;
